"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _PushMessage = _interopRequireDefault(require("@rsuite/icon-font/lib/application/PushMessage"));

// Generated by script, don't edit it please.
var PushMessage = (0, _createSvgIcon["default"])({
  as: _PushMessage["default"],
  ariaLabel: 'push message',
  category: 'application',
  displayName: 'PushMessage'
});
var _default = PushMessage;
exports["default"] = _default;
module.exports = exports.default;